(ns common.transaction-process.templates.capman.real-estate
  (:require
   [common.transaction-process.templates.capman.common :as common]))

(def template-id :transaction-process-template/capman-real-estate)

(def ^:private strategy-fields
  ;; CapMan 2026-06: property-country / property-city dropped from the RE fields —
  ;; redundant with Target company country/city on the Target entity details card
  ;; (see Markus's comments). Removed from the strategy card here.
  [:transaction-process/distance-from-closest-major-city-km
   :transaction-process/passing-rent-on-necessity-based-retail
   :transaction-process/lettable-area-in-retail-use
   :transaction-process/pre-lease-sold-percentage])

(def ^:private strategy-field-configs
  "All Real Estate strategy fields are mandatory per CapMan testing feedback
  (2026-05-21). The Asset Risk Scorecard attestation + doc slot were removed
  because that artefact is delivered through the RM check flow, not the TP.
  Earnout is hidden for RE (2026-06): RE deals don't carry an earnout, so it's
  dropped from the shared Investment amounts breakdown for this strategy."
  {:transaction-process/earnout-amount
   {:field/visibility :visibility/hidden}

   :transaction-process/distance-from-closest-major-city-km
   {:field/visibility    :visibility/always
    :field/mandatoriness :mandatory/always}

   :transaction-process/passing-rent-on-necessity-based-retail
   {:field/visibility    :visibility/always
    :field/mandatoriness :mandatory/always}

   :transaction-process/lettable-area-in-retail-use
   {:field/label         "Lettable area in retail use (%)"
    :field/visibility    :visibility/always
    :field/mandatoriness :mandatory/always}

   :transaction-process/pre-lease-sold-percentage
   {:field/visibility    :visibility/always
    :field/mandatoriness :mandatory/always}})

(def template
  (common/build-template
   {:template-id            template-id
    :template-name          "Real Estate"
    :strategy-fields        strategy-fields
    :strategy-field-configs strategy-field-configs
    :strategy-card-label    "Real estate fields"
    :strategy-card-subtitle "Fields specific to the Real Estate strategy"}))
